import { createFileRoute, redirect } from '@tanstack/react-router'
import PrinterDashboard from '@/pages/PrinterDashboard'

export const Route = createFileRoute('/staff-printer')({
  component: PrinterDashboard,
  beforeLoad: () => {
    // Check if staff is authenticated
    const staffAuth = localStorage.getItem('digimataam_staff_auth')
    const restaurantId = localStorage.getItem('digimataam_staff_restaurant')

    // Determine redirect URL - use staff login if restaurant ID is stored
    const redirectUrl = restaurantId ? `/staff-login?restaurant=${restaurantId}` : '/'

    if (!staffAuth) {
      throw redirect({ to: redirectUrl })
    }

    try {
      const staff = JSON.parse(staffAuth)
      if (staff.role !== 'printer') {
        throw redirect({ to: redirectUrl })
      }
    } catch {
      localStorage.removeItem('digimataam_staff_auth')
      throw redirect({ to: redirectUrl })
    }
  },
})
